import React from 'react';
import { motion } from 'framer-motion';
import { Baby, AlertTriangle, Heart } from 'lucide-react';
import { AgeRangeSelector } from './AgeRangeSelector';
import { SafetyGuidelines } from './SafetyGuidelines';
import { BabyMenuOptions } from './BabyMenuOptions';

interface BabyMenuSectionProps {
  selectedAge: string;
  maxPrice: number;
  courseCount: number;
  onAgeSelect: (age: string) => void;
  onUpdateMaxPrice: (price: number) => void;
  onUpdateCourseCount: (count: number) => void;
}

export const BabyMenuSection: React.FC<BabyMenuSectionProps> = ({
  selectedAge,
  maxPrice,
  courseCount,
  onAgeSelect,
  onUpdateMaxPrice,
  onUpdateCourseCount
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-lg p-6 shadow-lg mb-8"
    >
      <div className="flex items-center gap-3 mb-6">
        <Baby className="text-pink-500" size={32} />
        <div>
          <h2 className="text-2xl font-bold text-gray-800">Menú para Bebés</h2>
          <p className="text-gray-600">Alimentación segura y nutritiva para tu bebé</p>
        </div>
      </div>

      <div className="bg-white rounded-lg p-4 mb-6">
        <div className="flex items-start gap-2 text-amber-600">
          <AlertTriangle size={20} className="mt-1 flex-shrink-0" />
          <p className="text-sm">
            Consulta siempre con tu pediatra antes de introducir nuevos alimentos en la dieta de tu bebé.
            Las recomendaciones pueden variar según el desarrollo individual.
          </p>
        </div>
      </div>

      <AgeRangeSelector selectedAge={selectedAge} onAgeSelect={onAgeSelect} />
      
      <BabyMenuOptions
        maxPrice={maxPrice}
        courseCount={courseCount}
        onUpdateMaxPrice={onUpdateMaxPrice}
        onUpdateCourseCount={onUpdateCourseCount}
      />

      <SafetyGuidelines />
    </motion.div>
  );
};